<template>
  <div class="differentiating-benefits-relevance-content" id="plataforma-de-marca-beneficios-diferenciadores-relevancia" data-search-anchor>    

    <div class="differentiating-benefits-relevance-overlay-title-image">
      <h1 class="differentiating-benefits-relevance-image-relevance-title" style="margin-top: 4rem;">
        {{ differentiatingBenefitsRelevanceImageTitle }}
      </h1>
      <h1 class="differentiating-benefits-relevance-image-relevance-title" style="margin-bottom: 2rem;">
        {{ differentiatingBenefitsRelevanceImageTitle2 }}
      </h1>
      <p class="differentiating-benefits-relevance-image-relevance-text">
        {{ differentiatingBenefitsRelevanceImageTitle3 }}
      </p>
    </div>

    <div
      class="differentiating-benefits-relevance-banner-image"
      :style="{ backgroundImage: `url(${differentiatingBenefitsRelevanceImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import DifferentiatingBenefitsPageMixin from '@/mixins/differentiating-benefits-page-mixin'
import { DifferentiatingBenefitsPageStore } from '@/store/brand-plataform-page/differentiating-benefits-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class DifferentiatingBenefitsRelevanceSection extends Mixins(
  DifferentiatingBenefitsPageMixin
) {
  differentiatingBenefitsPageStore: PageStoreContract = getModule(
    DifferentiatingBenefitsPageStore,
    this.$store
  )

  get differentiatingBenefitsRelevanceImageTitle(): string {
    return this.getElementText(2, 0)
  }

  get differentiatingBenefitsRelevanceImageSrc(): string {
    return this.getElementMedia(2, 0)
  }

  get differentiatingBenefitsRelevanceImageTitle2(): string {
    return this.getElementText(2, 1)
  }

  get differentiatingBenefitsRelevanceImageTitle3(): string {
    return this.getElementText(2, 2)
  }

  async getDifferentiatingBenefitsPageStore(): Promise<void> {
    await this.differentiatingBenefitsPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.differentiatingBenefitsPageStore.isLoading) {
      await this.getDifferentiatingBenefitsPageStore()
    }
  }
}
</script>

<style lang="scss">
.differentiating-benefits-relevance-content {
  display: grid;
  grid-template-columns: 47% 53%;
  width: 100%;
  max-width: 1032px;       
}

.differentiating-benefits-relevance-overlay-title-image {
  max-width: 416px;
  width: 100%;
  height: 465px;  
}

.differentiating-benefits-relevance-image-relevance-title {
  font-size: 40px;
  font-weight: 400;
  letter-spacing: -0.01em;  
  margin: 0;
}

.differentiating-benefits-relevance-image-relevance-text {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 32px;  
  width: 416px;
  margin: 0;
}


.differentiating-benefits-relevance-banner-image {
  margin-top: 64px;
  position: relative;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  height: 600px;  
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
</style>
